import * as Assets from '../assets';

export interface Slide {
    type: 'model' | 'animation' | 'image',
    content: string | Assets.Asset,
    image?: Assets.Asset
}

export const characters: Slide[] = [
    { type: 'model', content: 'duck', image: Assets.duck },
    { type: 'model', content: 'anubisHead', image: Assets.anubisHead },
    { type: 'model', content: 'spider', image: Assets.spider }
];
export const furniture: Slide[] = [
    { type: 'model', content: 'bed', image: Assets.bed },
    { type: 'model', content: 'oneLegChair', image: Assets.oneLegChair },
    { type: 'model', content: 'armChair', image: Assets.armChair },
    { type: 'model', content: 'officeChair', image: Assets.officeChair },
    { type: 'model', content: 'sideTable', image: Assets.sideTable },
    { type: 'model', content: 'tabouret', image: Assets.tabouret },
    { type: 'model', content: 'nightStand', image: Assets.nightStand },
    { type: 'model', content: 'cabinet', image: Assets.cabinet },
    { type: 'model', content: 'desk', image: Assets.desk },
    { type: 'model', content: 'coffeeTable', image: Assets.coffeeTable }
];

export const animEnv: Slide[] = [
    { type: 'animation', content: Assets.tombAnimation },
    { type: 'animation', content: Assets.duckAnimation },
    { type: 'animation', content: Assets.spiderAnimation },
    { type: 'image', content: Assets.egiptianTomb },
    { type: 'image', content: Assets.room },
    { type: 'image', content: Assets.roomCloser }
];